import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
	{
		path: '/',
		name: 'main',
		component: () => import('../views/Main.vue')
	},
	{
		path: '/deckMaker',
		name: 'deckMaker',
		component: () => import('../components/DeckMaker/DeckMaker.vue')
	},
]

const router = createRouter({
	history: createWebHashHistory(),
	routes
})

export default router
